import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaSignInAlt, FaChevronDown, FaGlobe } from 'react-icons/fa';
import logoImage from '../images/logo.png';
import { useLanguage } from '../contexts/LanguageContext';
import './Header.css';

const Header = ({ onOpenPlatformModal }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const { currentLanguage, changeLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 80; // altura aproximada do header
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const openPlatformModal = () => {
    if (onOpenPlatformModal) {
      onOpenPlatformModal();
    }
    setIsMobileMenuOpen(false);
  };

  const languages = [
    { code: 'pt', name: 'Português', flag: '🇧🇷' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' }
  ];

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsLanguageOpen(false);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <img src={logoImage} alt="CodeArtisan" className="logo-img" />
        </div>

        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <button onClick={() => scrollToSection('hero')} className="nav-link">{t('nav.home')}</button>
          <button onClick={() => scrollToSection('devices')} className="nav-link">{t('nav.devices')}</button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">{t('nav.contact')}</button>
          
          {/* Seletor de Idiomas */}
          <div className="language-selector">
            <button 
              className="language-btn"
              onClick={() => setIsLanguageOpen(!isLanguageOpen)}
            >
              <FaGlobe />
              <span>{languages.find(lang => lang.code === currentLanguage)?.flag}</span>
              <FaChevronDown className={`chevron ${isLanguageOpen ? 'open' : ''}`} />
            </button>
            
            {isLanguageOpen && (
              <div className="language-dropdown">
                {languages.map((language) => (
                  <button
                    key={language.code}
                    className={`language-option ${currentLanguage === language.code ? 'active' : ''}`}
                    onClick={() => handleLanguageChange(language.code)}
                  >
                    <span>{language.flag}</span>
                    <span>{language.name}</span>
                  </button>
                ))}
              </div>
            )}
          </div>

          <button onClick={openPlatformModal} className="nav-platform">
            <FaSignInAlt /> {t('nav.enterPlatform')}
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-cta">
            {t('nav.requestQuote')}
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;

